import FastMarquee from "react-fast-marquee";

const WORDS = ["Clarity", "Healing", "Presence", "Awareness", "Stillness", "Alignment", "Compassion", "Renewal"];

export default function Marquee() {
  return (
    <section data-testid="marquee-section" className="py-10 md:py-14 border-y border-[rgba(200,149,54,0.2)] bg-[var(--alt)] overflow-hidden">
      <FastMarquee speed={38} gradient={false} pauseOnHover>
        {WORDS.map((w, i) => (
          <span key={i} className="flex items-center">
            <span className="marquee-item px-8">{w}</span>
            <span className="text-[var(--gold)] text-2xl">&#10022;</span>
          </span>
        ))}
      </FastMarquee>
    </section>
  );
}
